import type { AssetTimelineProps } from "./asset-timeline.type";

import { DatePicker, Timeline } from "antd";
import classNames from "classnames";
import InfiniteScroll from "react-infinite-scroll-component";

import { FetchDataWrapper } from "@/modules/fetch-data-wrapper";

import { AssetTimelineEventTypePicker } from "./asset-timeline-event-type-picker";
import { AssetTimelineItemCard } from "./asset-timeline-item-card";
import { withInfiniteScrollLoader } from "./asset-timeline-scroll-loader";
import { useAssetTimelineData } from "./asset-timeline.hook";

import "./asset-timeline.style.less";

const { RangePicker } = DatePicker;

export const AssetTimeline = ({ assetId }: AssetTimelineProps) => {
  const {
    items,
    error,
    isLoading,
    isEmpty,
    hasNextPage,
    isFetchingNextPage,
    onLoadMore,
    onRangeChange,
    onTypeChange,
  } = useAssetTimelineData(assetId);

  return (
    <div className="asset-timeline">
      <div className="asset-timeline-header">
        <RangePicker onChange={onRangeChange} />
        <AssetTimelineEventTypePicker onEventTypeChange={onTypeChange} />
      </div>
      <FetchDataWrapper
        data={items}
        error={error}
        loading={isLoading}
        isEmpty={isEmpty}
      >
        <InfiniteScroll
          // scrollableTarget props is not provided
          // -> the default scrollable target is body
          dataLength={items.length}
          hasMore={hasNextPage}
          next={onLoadMore}
          loader={<></>}
        >
          <Timeline
            mode="alternate"
            className={classNames({
              "asset-timeline-scroll-loading": isFetchingNextPage,
            })}
            classNames={{
              root: "asset-timeline--root",
              item: "asset-timeline--item",
              itemIcon: "asset-timeline--item-icon",
            }}
            items={withInfiniteScrollLoader({
              items: items.map((item, index) => ({
                color: item.color,
                className: classNames({
                  "asset-timeline-item-indicator": item.isIndicator,
                  "asset-timeline-item-in-futur": item.isInFutur,
                  "asset-timeline-item-before-futur": item.isBeforeFutur,
                  "asset-timeline-item-last": index === items.length - 1,
                }),
                content: <AssetTimelineItemCard item={item} key={item.key} />,
                placement: item.isIndicator ? "end" : "start",
              })),
              isFetchingNextPage,
            })}
          />
        </InfiniteScroll>
      </FetchDataWrapper>
    </div>
  );
};
